import aiChatbotApi from 'services/ai-assistant-api';
import serviceApi from 'services/api';
import auth from 'services/auth';

const api = process.env.REACT_APP_ENVIRONMENT === 'local' ? auth : serviceApi;

interface AIAssistantResponse {
  [key: string]: string;
}

interface AIResponse {
  message: string;
  sessionId: string;
}

interface AIAssistantRequest {
  session_id?: string;
  roleUuid: string;
  prompt: string;
}

export type ChatBotSessionProps = {
  session_id: string;
  role_uuid: string;
  conversation: string;
};

/**
 * The SendFeedbackRequest type represents a request to send feedback.
 */
export type SendFeedbackRequest = {
  is_good: boolean;
  session_id: string;
  chat?: string;
  feedback?: string;
};

/**
 * The SendFeedbackResponse type represents a response from SendFeedback.
 */
export type SendFeedbackResponse = {
  uuid: string;
  is_good: boolean;
  session_id: string;
  chat: string;
  feedback?: string;
};

/* The function `fetchAIResponse` is an asynchronous function that makes a POST request to the `/chatbot` endpoint with the payload and returns
the ai chatbot response. */
const fetchAIResponse = async (payload: AIAssistantRequest): Promise<AIResponse> => {
  const response = await aiChatbotApi.post<AIAssistantResponse>('/chatbot', payload);

  // Extract the key (sessionId) and value (message)
  const responseData = response.data;
  const sessionId = Object.keys(responseData)[0];
  const message = responseData[sessionId];

  return { message, sessionId };
};

/* The function `GetChatBotSession` is an asynchronous function that makes a GET request to the `/apiv1/admin/chatbot/session` endpoint and returns
all the session data with conversation in the response. */
const GetChatBotSession = async () => {
  const response = await api.get<ChatBotSessionProps>('/apiv1/admin/chatbot/session');
  return response?.data;
};

/* The function `SendFeedback` is an asynchronous function that makes a POST request to the `/apiv1/admin/chatbot/feedback` endpoint with the payload and returns
the feedback response. */
const SendFeedback = async (payload: SendFeedbackRequest, feedbackUuid?: string) => {
  let url = '/apiv1/admin/chatbot/feedback';
  if (feedbackUuid) {
    url += `?feedback_uuid=${feedbackUuid}`;
  }

  const response = await api.post<SendFeedbackResponse>(url, payload);
  return response?.data;
};

const AIAssistantService = {
  fetchAIResponse,
  GetChatBotSession,
  SendFeedback
};

export default AIAssistantService;
